import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";
type BtnCreateProps ={
    txtBtn:string ,    
    id?:number,
    openModal:(id:number)=> void,
    disabledBtn?:boolean
  }
const BtnCreate = ({txtBtn,id=0,openModal,disabledBtn=false}:BtnCreateProps) => {
  return (
   <>
   { disabledBtn ? 
     <button
     className="performCol_botonInactive"
     disabled             
     >   
    <div className="alineacionBoton">  
      <img src={AddIcon} alt="" />
          <div className="nombrePrestacion">
           <b><span>{txtBtn}</span> </b>
          </div>
    </div>
   </button>
   :
    <button
    id="addPrestacion"     
    onClick={()=>openModal(id)}
    className="btnNuevaPrestacion"
      >
      <div className="alineacionBoton">
        <img src={AddIcon} alt="" />
        <div className="nombrePrestacion">
          <b><span>{txtBtn}</span> </b>
        </div>
      </div>
    </button>   
   }
   </>
  )}

export default BtnCreate